export default {
  install(Vue, options) {
    Vue.prototype.constant = {
      DomainType: {
        // 空
        TYPE_NULL: 0,
        // 仅用于制作模板
        // 内框
        TYPE_MAKE_IN: 100,
        // 选择
        TYPE_MAKE_SELECT: 101,
        // 识别
        TYPE_MAKE_SPOT: 102,
        // 仅用于题卡
        // 客观题-单选
        TYPE_OBJ_SINGLE: 200,
        // 客观题-多选
        TYPE_OBJ_MULTIPLE: 201,
        // 主观分-红笔单选
        TYPE_SUB_RED: 210,
        // 主观分-填空题-红笔对错
        TYPE_SUB_FILL_RED_VAC: 211,
        // 主观分-解答题-红笔对错
        TYPE_SUB_ANSWER_RED_VAC: 212,
        // 填空题-英语自动识别
        TYPE_SUB_FILL_AUTO: 215,
        // 解答题-英语自动识别
        TYPE_SUB_ANSWER_AUTO: 216,
        // 二维码
        TYPE_CODE_QRC: 220,
        // 条码
        TYPE_CODE_BAR: 221,
        // 识别点-单选
        TYPE_DIS_SINGLE: 230,
        // 识别点-多选
        TYPE_DIS_MULTIPLE: 231,
        // 识别点-错误原因
        TYPE_DIS_REASON: 232,
        // 识别点-错误知识点
        TYPE_DIS_KNOWLEDGE: 233,
        // 识别点-错误小题
        TYPE_DIS_SUB: 235,
        // 定位线
        TYPE_LOC_LINE: 240,
        // 定位点
        TYPE_LOC_POINT: 241,
        // 考号
        TYPE_NUB: 250,
        // 切割区-填空题作答区域
        TYPE_CUT_FILL: 260,
        // 切割区-解答题作答区域
        TYPE_CUT_ANSWER: 261,
        // 切割区-整道试题
        TYPE_CUT_QUESTION: 262,
        // 切割区-整张试卷
        TYPE_CUT_PAGE: 263,
        // 小题题号标记
        TYPE_TAG_NO_QUESTION: 270,
        // 大题题号标记
        TYPE_TAG_NO_SECTION: 271,
        // 解答题作答区域标记-开始
        TYPE_TAG_ANSWER_START: 272,
        // 解答题作答区域标记-结束
        TYPE_TAG_ANSWER_END: 273
      },
      PageItemType: {
        NONE: 0, // 空
        HEADER: 1, // 头部
        SECTION: 2, // 大题标题
        TRUNK: 2, // 题干
        HY_SELECT: 101, // 题卡合一 - 选择题
        HY_FILL: 102, // 题卡合一 - 填空题
        HY_ANSWER: 103, // 题卡合一 - 解答题
        DL_SELECT: 201, // 独立答题卡 - 选择题
        DL_FILL: 202, // 独立答题卡 - 填空题
        DL_ANSWER: 203, // 独立答题卡 - 解答题
        CT_SELECT: 301 // 错题卡 - 填涂域
      },
      WrongReason: {
        1: {
          Id: 1,
          Name: "审题错误"
        },
        2: {
          Id: 3,
          Name: "粗心大意"
        },
        3: {
          Id: 6,
          Name: "概念模糊"
        },
        4: {
          Id: 4,
          Name: "计算错误"
        },
        5: {
          Id: 10,
          Name: "惯性思维"
        },
        6: {
          Id: 12,
          Name: "知识点未掌握"
        }
      },
      cardTypeStr: {
        1: "题卡合一",
        3: "独立答题卡"
        // 2: '错题卡'
      },
      cardType: [
        { name: "题卡合一", type: 1 },
        { name: "独立答题卡", type: 3 }
        // {name: '错题卡', type: 2}
      ],
      locType: [
        { name: "定位线", type: 0 },
        { name: "定位点", type: 1 }
      ],
      collType: [
        { name: "收集", type: 1 },
        { name: "不收集", type: 0 }
      ],
      supportType: [
        { name: "支持", type: 1 },
        { name: "不支持", type: 0 }
      ],
      stdNoType: [
        { name: "填涂考号", type: 0 },
        { name: "条码考号", type: 1 }
      ],
      columnNumber: [
        { name: "A4/1栏（可打印成A3/8K两栏）", type: 1 },
        { name: "A3/3栏（可打印成A3/8K三栏）", type: 2 }
      ],
      scoreType: [
        { name: "加分", type: 0 },
        { name: "减分", type: 1 }
      ],
      fillType: [
        { name: "分数格", type: 0 },
        { name: "手写批改", type: 1 },
        { name: "加入错题", type: 2 }
      ],
      ansTyp: [
        { name: "分数格", type: 0 },
        { name: "加入错题", type: 1 },
        { name: "手写批改", type: 2 }
      ],
      imagePosition: {
        1: "内容下方",
        2: "内容右侧",
        3: "答题框内"
      },
      subjectMap: {
        UNKNOWN: { k: 0, v: "未知" },
        XYUWEN: { k: 101, v: "小学语文" },
        XSHUXUE: { k: 102, v: "小学数学" },
        XYINGYU: { k: 103, v: "小学英语" },
        XKEXUE: { k: 104, v: "小学科学" },

        CYUWEN: { k: 201, v: "初中语文" },
        CSHUXUE: { k: 202, v: "初中数学" },
        CYINGYU: { k: 203, v: "初中英语" },
        CWULI: { k: 204, v: "初中物理" },
        CHUAXUE: { k: 205, v: "初中化学" },
        CSHENGWU: { k: 206, v: "初中生物" },
        CDILI: { k: 207, v: "初中地理" },
        CKEXUE: { k: 208, v: "初中科学" },
        CZHENGZHI: { k: 209, v: "初中社会" },

        GYUWEN: { k: 301, v: "高中语文" },
        GSHUXUE: { k: 302, v: "高中数学" },
        GYINGYU: { k: 303, v: "高中英语" },
        GWULI: { k: 304, v: "高中物理" },
        GHUAXUE: { k: 305, v: "高中化学" },
        GSHENGWU: { k: 306, v: "高中生物" },
        GJSHUXUE: { k: 602, v: "高中先修数学" },

        SHUXUE: { k: 1, v: "数学" },
        YINGYU: { k: 2, v: "英语" },
        KEXUE: { k: 3, v: "科学" },
        BAIKE: { k: 99, v: "百科" },
        ZONGHE: { k: 100, v: "综合" }
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/config/constant.js